import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Indlæser...")
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]


import { useQuery, useResult } from "@vue/apollo-composable";
import { FigurISaet } from "@/types/legotyper";
import { FIGURER_I_SAET_FOR_UUID_OPSLAG } from "@/constants/graphql";
import Minifigurtabel from "@/components/base/Minifigurtabel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LegoSetMinifigurer',
  props: {
    uuid: null
  },
  setup(__props: any) {

const props = __props as {
  uuid: string;
}



const { result: figurResult, loading: figurLoading } = useQuery<FigurISaet[]>(
  FIGURER_I_SAET_FOR_UUID_OPSLAG,
  props
);

const figurer = useResult(figurResult, null);

return (_ctx: any,_cache: any) => {
  return (!_unref(figurLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Minifigurtabel, {
          figurer: _unref(figurer),
          "vis-antal-i-saet": true
        }, null, 8, ["figurer"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}
}

})